<template>
	<div id="printDiv" class="printDiv">
		<div class="row-me center-all title">
			<span style="font-size: 25px;">{{printTitle}}</span>
		</div>
		<div style="margin-top: 20px;">
			<div v-if="printType===0">
				<div class="table-print-border" style="font-size: 16px;">
					<div class="row-me">
						<div class="table-print-header">药品名称</div>
						<div class="table-print-header">销售数量</div>
						<div class="table-print-header">成本总价</div>
						<div class="table-print-header">销售总价</div>
						<div class="table-print-header">利润</div>
					</div>
					<div class="row-me" v-for="(item,index) in tableData" :key="index">
						<div class="table-print-cell">{{item.name}}</div>
						<div class="table-print-cell">{{item.saleNums}}</div>
						<div class="table-print-cell">{{item.costTotalPrice}}</div>
						<div class="table-print-cell">{{item.saleTotalPrice}}</div>
						<div class="table-print-cell">{{item.profit}}</div>
					</div>
				</div>
			</div>
			<div v-if="printType===1">
				<div class="table-print-border" style="font-size: 16px;">
					<div class="row-me">
						<div class="table-print-header">传方日期</div>
						<div class="table-print-header">处方订单号</div>
						<div class="table-print-header">医院处方号</div>
						<div class="table-print-header">患者姓名</div>
						<div class="table-print-header">医院名称</div>
						<div class="table-print-header">销售数量合计</div>
						<div class="table-print-header">药品成本合计</div>
						<div class="table-print-header">药品销售合计</div>
						<div class="table-print-header">利润额</div>
						<div class="table-print-header">利润率</div>
					</div>
					<div class="row-me" v-for="(item,index) in tableData" :key="index">
						<div class="table-print-cell">{{item.createTime}}</div>
						<div class="table-print-cell">{{item.orderNo}}</div>
						<div class="table-print-cell">{{item.prescriptionNumber}}</div>
						<div class="table-print-cell">{{item.patientName}}</div>
						<div class="table-print-cell">{{item.hospitalName}}</div>
						<div class="table-print-cell">{{item.saleTotalNums}}</div>
						<div class="table-print-cell">{{item.drugCostTotal}}</div>
						<div class="table-print-cell">{{item.drugSaleTotal}}</div>
						<div class="table-print-cell">{{item.profit}}</div>
						<div class="table-print-cell">{{item.profitMargin}}</div>
					</div>
				</div>
			</div>
			<div v-if="printType===2">
				<div class="table-print-border" style="font-size: 16px;">
					<div class="row-me">
						<div class="table-print-header">传方日期</div>
						<div class="table-print-header">处方订单号</div>
						<div class="table-print-header">医院处方号</div>
						<div class="table-print-header">患者姓名</div>
						<div class="table-print-header">医院名称</div>
						<div class="table-print-header">项目名称</div>
						<div class="table-print-header">单位</div>
						<div class="table-print-header">销售数量</div>
						<div class="table-print-header">成本单价</div>
						<div class="table-print-header">成本总额</div>
						<div class="table-print-header">销售单价</div>
						<div class="table-print-header">销售总额</div>
					</div>
					<div class="row-me" v-for="(item,index) in tableData" :key="index">
						<div class="table-print-cell">{{item.createTime}}</div>
						<div class="table-print-cell">{{item.orderNo}}</div>
						<div class="table-print-cell">{{item.prescriptionNumber}}</div>
						<div class="table-print-cell">{{item.patientName}}</div>
						<div class="table-print-cell">{{item.hospitalName}}</div>
						<div class="table-print-cell">{{item.projectName}}</div>
						<div class="table-print-cell">{{item.unit}}</div>
						<div class="table-print-cell">{{item.saleNums}}</div>
						<div class="table-print-cell">{{item.costUnitPrice}}</div>
						<div class="table-print-cell">{{item.costTotalPrice}}</div>
						<div class="table-print-cell">{{item.saleUnitPrice}}</div>
						<div class="table-print-cell">{{item.saleTotalPrice}}</div>
					</div>
				</div>
			</div>
		</div>
		<button v-show="false" id="btnPrint" v-print="'#printDiv'"></button>
	</div>
</template>

<script>
	import print from 'print-js'
	export default {
		components: {

		},
		props: {
			printTitle: {
				type: String,
				default: '',
			},
			printType: {
				type: Number,
				default: -1,
			},
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {

			}
		},
		// 侦听器
		watch: {

		},
		// 计算属性
		computed: {

		},
		// html加载完成之前
		created() {

		},
		// html加载完成后执行。
		mounted() {

		},
		// 事件方法执行
		methods: {
			startPrint() {
				this.$nextTick(() => {
					document.getElementById("btnPrint").click();
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	/*去除页眉页脚*/
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 3mm;
		/* this affects the margin in the printer settings */
	}

	html {
		background-color: #FFFFFF;
		margin: 0;
		/* this affects the margin on the html before sending to printer */
	}

	body {
		border: solid 1px blue;
		margin: 10mm 15mm 10mm 15mm;
		/* margin you want for the content */
	}

	.printDiv {
		padding: 10px;

		.title {
			margin-top: 20px;
		}
	}
</style>
